module.exports = __webpack_public_path__ + "img/lookbook_7_left.ecfa0f48.png";